var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center text-primary"},[_c('font-awesome-icon',{staticClass:"fa-lg fa-10x fa-spin",attrs:{"icon":"spinner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }